import cn from 'clsx'
import OfferListExperienceTile from 'components/OfferList/v2/OfferListExperienceTile'
import OfferListOfferTile from 'components/OfferList/v2/OfferListOfferTile'
import { mediaQueryUp } from 'components/utils/breakpoint'
import React, { useState } from 'react'
import styled, { css } from 'styled-components'

const sharedStyles = css`
  ${mediaQueryUp.tablet} {
    &.non-interactive {
      pointer-events: none;

      /*
        We turn off pointer events to prevent users from interacting with items
        that are not fully visible but if they can see specific buttons (like 'view offer or 'save to trip')
        we still want them to be able to interact with those buttons.
      */
      button {
        pointer-events: auto;
      }
    }
  }
`

const HeroOfferTile = styled(OfferListOfferTile)`
  ${sharedStyles};
`

const ExperienceOfferTile = styled(OfferListExperienceTile)`
  ${sharedStyles};
`

interface Props {
  position: number;
  offerId: string;
  className?: string;
  tileStyle?: 'search' | 'hero' | 'frontpage';
}

function HeroOfferCarouselItem(props: Props) {
  const { offerId, position, className, tileStyle } = props
  const [inView, setInView] = useState<boolean>()
  /*
  * This is a temporary solution, the unified endpoint will provide information on the offer type.
  * We aren't showing experiences right now on the hero carousel. Just laying the ground work for future experiences.
  */
  const isExperience = offerId.includes('led')

  const sharedProps = {
    className: cn(className, { 'non-interactive': !inView }),
    position,
    onInViewChange: setInView,
    inViewThreshold: 0.9,
  }

  const offerTileProps = {
    ...sharedProps,
    tileStyle: tileStyle ?? 'hero',
    offerId,
  }

  const experienceTileProps = {
    ...sharedProps,
    experienceId: offerId,
  }

  return <>
    {!isExperience && <HeroOfferTile {...offerTileProps} fetchOnlyIfInView eagerLoadImage />}
    {isExperience && <ExperienceOfferTile {...experienceTileProps} />}
  </>
}

export default HeroOfferCarouselItem
